onceLoaded(() => {
    console.log('once loaded - theme.js');

    window.body = $('body');
    window.html = $('html');
    const $window = $(window);

    // Popper.js
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl)
    })

    // Header
    const header = $('#wrapper-navbar');
    $(document).off('.site').on('scroll.site', e => {
        if ($(document).scrollTop() >= header.height()) {
            $('body').addClass('sticky');
        } else {
            $('body').removeClass('sticky');
        }
    });


    // booking Widget
    const bookingWidget = window.body.find('.booking-widget')
    if (bookingWidget.length){
        let apartmentCode = window.body.find('.apartment-block').attr('data-apartment')

        const minDateSeason = '2024-03-23'
        const maxDateSeason = '2025-10-26'
        const arriveInput = bookingWidget.find('.arrivo input')
        const departureInput = bookingWidget.find('.partenza input')
        const apartmentWrapper = bookingWidget.find('.apartment-wrapper')
        const apartmentSelect = bookingWidget.find('.apartment select')
        const adultsSelect = bookingWidget.find('.adulti select')
        const messageTextArea = bookingWidget.find('.messaggio textarea')
        adultsSelect.val('2')
        arriveInput.attr('min', minDateSeason )
        arriveInput.attr('max', maxDateSeason )
        departureInput.attr('min', minDateSeason )
        departureInput.attr('max', maxDateSeason )
        messageTextArea.attr('rows', '5')
        //apartmentSelect.find('option').attr('disabled', true)

        apartmentSelect.find('option').length


        $(Utils.rooms).each((index, el) => {
            let currentOption = apartmentSelect.find('option')[index+1]
            $(currentOption).html(el.lang[Utils.getLanguage()])
            //apartmentSelect.append('<option value="' + el.code + '"' + selected + '>' + el.lang[Utils.getLanguage()] + '</option>')
        })
        if (apartmentCode === undefined){
            apartmentCode = 'BiloVite'
        }else{
            apartmentWrapper.hide()
        }

        let apartmentObject = Utils.buildObjectRoom(bookingWidget, apartmentCode)

        apartmentSelect.on('change', () => {
            apartmentObject = Utils.buildObjectRoom(bookingWidget, apartmentSelect.val())
            if (arriveInput.val() && departureInput.val()){
                let bookResults = Utils.holidayPrice(apartmentObject, arriveInput.val(), departureInput.val())
                Utils.populatePrice(bookingWidget, bookResults)
            }
        })


        arriveInput.change(() => {
            let dateArriveMin = new Date(arriveInput.val())
            let dateArriveSelected = new Date(arriveInput.val())
            dateArriveMin.setDate(dateArriveMin.getDate() + 3)
            dateArriveSelected.setDate(dateArriveSelected.getDate() + 7)
            departureInput.attr('min', Utils.formatDate(dateArriveMin) )
            departureInput.val(Utils.formatDate(dateArriveSelected) )
            let bookResults = Utils.holidayPrice(apartmentObject, arriveInput.val(), departureInput.val())
            Utils.populatePrice(bookingWidget, bookResults)

            bookingWidget.find('.hidden-price-discounted').val(bookResults.price.grandTotalPrice)
            bookingWidget.find('.hidden-price-original').val(bookResults.price.grandTotalRegular)

            if ((arriveInput.val() === '') || (departureInput.val() === '')){
                bookingWidget.find('.price-from').show()
                bookingWidget.find('.price-content').hide()
                bookingWidget.find('.hidden-price-discounted').val('')
                bookingWidget.find('.hidden-price-original').val('')
            }
        })

        departureInput.change(() => {
            let bookResults = Utils.holidayPrice(apartmentObject, arriveInput.val(), departureInput.val())
            Utils.populatePrice(bookingWidget, bookResults)
            if ((departureInput.val() === '') || (arriveInput.val() === '')){
                bookingWidget.find('.price-from').show()
                bookingWidget.find('.price-content').hide()
                bookingWidget.find('.hidden-price-discounted').val('')
                bookingWidget.find('.hidden-price-original').val('')
            }

        })

    }

    // Check-in form
    const checkInForm = window.body.find('.template-check-in')
    if (checkInForm.length){
        const addComponentButton = checkInForm.find('.js-add-component')
        const componentBase = checkInForm.find('.component')
        const componentsContainer = checkInForm.find('.components-container')
        let index = addComponentButton.attr('data-guest')
        addComponentButton.on('click', () => {
            var element = componentBase.clone()
            element.find('.cognome-component input').attr('name', 'cognome-component-'+index)
            element.find('.nome-component input').attr('name', 'nome-component-'+index)
            element.find('.cittadinanza-component input').attr('name', 'cittadinanza-component-'+index)
            element.find('.sesso-component select').attr('name', 'sesso-component-'+index)
            element.find('.nascita-data-component input').attr('name', 'nascita-data-component-'+index)
            element.find('.nascita-luogo-component input').attr('name', 'nascita-luogo-component-'+index)
            componentsContainer.append(element)
            element.fadeIn()
            index++
        })
        $(document).on('click','.js-remove-component',(el) =>{
            let currentBtn = $(el.target)
            currentBtn.closest('.component').remove()
        })
    }

    // Custom Slider
    const customSlider = window.body.find('.custom-slider')
    if (customSlider.length){
        customSlider.each((index, el) => {
            let slider = $(el)
            let infinite = Utils.stringToBoolean(slider.attr('data-infinite'))
            let slideToShow = slider.attr('data-slideToShow')
            let dots = Utils.stringToBoolean(slider.attr('data-dots'))
            let arrows = Utils.stringToBoolean(slider.attr('data-arrows'))
            let autoplay = Utils.stringToBoolean(slider.attr('data-autoplay'))
            let fade = Utils.stringToBoolean(slider.attr('data-fade'))
            let autoplaySpeed = slider.attr('data-autoplaySpeed')
            let variableWidth = Utils.stringToBoolean(slider.attr('data-variableWidth'))
            let adaptiveHeight = Utils.stringToBoolean(slider.attr('data-adaptiveHeight'))
            let responsive = false
            let responsiveLgSlideToShow = slider.attr('data-responsive-lg-slideToShow')
            let responsiveLgVariableWidth = Utils.stringToBoolean(slider.attr('data-responsive-lg-variableWidth'))
            let responsiveMdSlideToShow = slider.attr('data-responsive-md-variableWidth')
            let responsiveMdVariableWidth = Utils.stringToBoolean(slider.attr('data-responsive-md-variableWidth'))
            if (responsiveLgSlideToShow){
                let objLg = {
                    breakpoint: window.responsive.breakpoints.lg,
                    settings: {
                        slidesToShow: responsiveLgSlideToShow,
                        variableWidth: responsiveLgVariableWidth,
                        slidesToScroll: 1,
                        mobileFirst: true,
                    }
                }
                responsive = []
                responsive.push(objLg)
            }
            if (responsiveMdSlideToShow){
                let objMd = {
                    breakpoint: window.responsive.breakpoints.md,
                    settings: {
                        slidesToShow: responsiveMdSlideToShow,
                        variableWidth: responsiveMdVariableWidth,
                        slidesToScroll: 1,
                        mobileFirst: true,
                    }
                }
                if (!responsive){
                    responsive = []
                }
                responsive.push(objMd)
            }
            slider.slick({
                infinite: infinite,
                slidesToShow: slideToShow || 3,
                dots: dots,
                arrows: arrows,
                autoplay: autoplay,
                autoplaySpeed: autoplaySpeed || 3000,
                variableWidth: variableWidth,
                adaptiveHeight: adaptiveHeight,
                fade: fade,
                slidesToScroll: 1,
                mobileFirst: true,
                accessibility: false,
                prevArrow: '<button class="slick-prev slick-arrow" aria-label="Prev" type="button" style="left: .5rem"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 26 50.9" xml:space="preserve"><polyline points="25.6,0.4 0.7,25.5 25.6,50.6 "></polyline></svg></button>',
                nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="right: 1rem"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 26 50.9" xml:space="preserve"><polyline points="0.4,50.6 25.3,25.5 0.4,0.4 "></polyline></svg></button>',
                responsive: responsive,

            })
        })
    }

    $(document).ready(function() {
        //Preloading animation
        let preloaderFadeOutTime = 600;
        function fadePreloader() {
            var preloader = $(".loader-wrapper");
            preloader.fadeOut(preloaderFadeOutTime);
        }
        fadePreloader();
    });
})